/* eslint-disable react-hooks/exhaustive-deps */
import { selectCurrentUser, selectIsSidebarOpen, selectIsLogoutInProgress } from '../slice/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { adminActions } from '../slice';
import { useMediaQuery } from '@mui/material';
import { useState } from 'react';

export const useSideBarHandler = () => {
  const dispatch = useDispatch();
  const isSidebarOpen = useSelector(selectIsSidebarOpen);
  const xsScreen = useMediaQuery('(max-width: 600px)');
  const [initiateLogout, setInitiateLogout] = useState(false);
  const isLogoutInProgress = useSelector(selectIsLogoutInProgress);
  const currentUser = useSelector(selectCurrentUser);

  const toggleSidebar = (state?: boolean) => {
    dispatch(adminActions.toggleSidebar(state));
  };

  const handleLogout = () => {
    dispatch(adminActions.logout());
  };

  return { isSidebarOpen, toggleSidebar, xsScreen, handleLogout, initiateLogout, setInitiateLogout, isLogoutInProgress, currentUser };
};
